import { css } from 'styled-components';

export const TechnicalErrorContent = css(({ theme }) => {
  return css`
    display: flex;
    align-items: center;
    flex-direction: column;
    height: 100%;

    > .technical-issue-icon {
      width: 170px;
      height: 100px;
    }

    > .text {
      color: ${theme.colors.primaryDeepBlue};
      text-align: center;
    }

    > .title {
      font-weight: 600;
      font-size: 25px;
      line-height: 30px;
    }

    > .subtitle {
      font-weight: 500;
      font-size: 18px;
      line-height: 27px;
      margin-top: 12px;
    }

    > .description {
      font-weight: 600;
      font-size: 14px;
      line-height: 21px;
      margin-top: 8px;
    }

    > .page-button {
      margin-top: 39px;
      width: 246px;
      > .button-label {
        font-weight: 700;
        font-size: 14px;
        line-height: 21px;
        margin-left: 6px;
      }
    }
  `;
});
